import { Directive, Output, inject, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MessagingService } from '../../infrastructure/messaging/messaging.service';
import { RefreshEditOptionsMessage } from '../../domain/models/messages';
import { UniqueEventEmitter } from '../../lib/unique-event-emitter';

/**
 * Shared plumbing of the sub-menu option panels: the reset subscription to
 * RefreshEditOptionsMessage, the deduplicating `changed` output and the
 * apply/cancel outputs with their handlers.
 *
 * Subclasses implement {@link refresh} to restore their defaults (and
 * re-emit initial options if the panel reports any); `changed` is already
 * reset by the base when refresh runs.
 */
@Directive()
export abstract class EditOptionsPanelBase<TOptions> {
  @Output() changed = new UniqueEventEmitter<TOptions>();

  readonly apply = output<void>();

  readonly cancelRequested = output<void>();

  constructor() {
    inject(MessagingService)
      .of(RefreshEditOptionsMessage)
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.changed.reset();
        this.refresh();
      });
  }

  onApply(): void {
    this.apply.emit();
  }

  onCancel(): void {
    this.cancelRequested.emit();
  }

  protected abstract refresh(): void;
}
